import CheckMarkIcon from '@nv/images/design/check-mark-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './VotedStatus.module.scss'

const VotedStatus = ({ hasVoted }) => {
  const { t } = useTranslation()

  const getColorClassTag = (hasVoted) => {
    return hasVoted ? '--success' : '--warning'
  }

  return (
    <div className={clsx(styles['status'], styles[`status${getColorClassTag(hasVoted)}`])}>
      {hasVoted && <CheckMarkIcon className={styles['status__check-icon']} color={'var(--color-white)'} />}
      <span className={styles['status__txt-value']}>{hasVoted ? t('events.voters.voted') : t('events.voters.notVoted')}</span>
    </div>
  )
}

export default VotedStatus
